import { useMemo, useContext } from "react";

import { Gear } from "components/icons/generated";
import { ThemeContext } from "views/Theme";
import { Theme } from "types/Theme";

import { CommandPaletteActionType, CommandPaletteBucket } from "../types";
import { BUCKET_IDS } from "../constants";

const useCommandPaletteSettingsBucket = (): CommandPaletteBucket => {
  const themeContext = useContext(ThemeContext);

  return useMemo(
    () => ({
      id: BUCKET_IDS.SETTINGS,
      title: "Settings",
      order: 100,
      getActions: () => [
        {
          type: CommandPaletteActionType.SIMPLE,
          id: "toggle-theme",
          title: "Toggle theme",
          keywords: ["dark", "light", "appearance"],
          bucketId: BUCKET_IDS.SETTINGS,
          icon: Gear,
          keepModalOpen: true,
          onAction: () => {
            if (!themeContext) return;

            if (themeContext.syncThemeWithSystem) {
              themeContext.setSyncThemeWithSystem(false);
            }

            const newTheme = themeContext.currentTheme === Theme.Light ? Theme.Dark : Theme.Light;

            themeContext.changeTheme(newTheme);
          },
        },
      ],
    }),
    [themeContext]
  );
};

export default useCommandPaletteSettingsBucket;
